import { useState } from "react";
import axios from "axios";

interface UseVerificationOptions {
  taskId?: number;
  onSuccess?: () => void;
}

export const useVerification = (options: UseVerificationOptions = {}) => {
  const [isLoading, setIsLoading] = useState(false);

  const verifyWithClear = async () => {
    setIsLoading(true);

    try {
      const response = await axios.post("/clear_me/verification", {
        identity_verification_task_id: options.taskId,
      });

      if (response.data.verify_url) {
        options.onSuccess?.();
        window.location.href = response.data.verify_url as string;
      } else {
        throw new Error("No verify_url received from verification service");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    verifyWithClear,
    isLoading,
  };
};
